/* --------------------------------------------------------------------------
 * salesTotals.js — realised-profit + sales-value rollups.
 *
 * Consumed by:
 *   CollectionDetail  (Collection KPIs)
 *   Analytics         (Portfolio KPIs)
 *
 * Kept intentionally small — one function that returns every KPI the spec
 * calls out. Callers pass in the sales array from GET /api/sales and the
 * current unrealised-value totals (already NZD-normalised) so the
 * "combined performance" number blends the two without duplicating the
 * itemCostNZD / itemValueNZD math this repo already owns.
 * -------------------------------------------------------------------------- */
export function summariseSales(sales = []) {
  let realisedEx = 0;
  let realisedInc = 0;
  let qtySold = 0;
  let saleValueEx = 0;
  let saleValueInc = 0;
  for (const s of sales) {
    const qty = Number(s.quantity_sold || 0);
    realisedEx += Number(s.realised_profit_ex_gst || 0);
    realisedInc += Number(s.realised_profit_inc_gst || 0);
    qtySold += qty;
    saleValueEx += Number(s.sale_price_ex_gst || 0) * qty;
    saleValueInc += Number(s.sale_price_inc_gst || 0) * qty;
  }
  return {
    realisedEx,
    realisedInc,
    qtySold,
    saleValueEx,
    saleValueInc,
  };
}
